// extracted by mini-css-extract-plugin
export default {"PlayersContainer":"playersOfMonth_PlayersContainer__fle6F"};